import { useNavigate, useLocation } from "react-router-dom";
import "../../../styles/Auth/settings.css";

const SettingsHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = localStorage.getItem("role") || sessionStorage.getItem("role");
    const isSuperOrSelfAdmin = role === "SuperAdmin" || role === "SelfAdmin";

    return (
        <div className="settings-widgets" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <button
                className={`profile-settings ${location.pathname === "/settings/profile" ? "active" : ""}`}
                onClick={() => navigate("/settings/profile")}
            >
                Profile
            </button>

            {isSuperOrSelfAdmin && (
                <>
                    <button
                        className={`profile-settings ${location.pathname.includes("/legal-documents/privacy-policy") ? "active" : ""}`}
                        onClick={() => navigate("/settings/legal-documents/privacy-policy")}
                    >
                        Privacy Policy
                    </button>
                    <button
                        className={`profile-settings ${location.pathname.includes("/legal-documents/terms-and-conditions") ? "active" : ""}`}
                        onClick={() => navigate("/settings/legal-documents/terms-and-conditions")}
                    >
                        Terms &amp; Conditions
                    </button>
                </>
            )}
        </div>
    );
};

export default SettingsHeader;
